<template>
	<div>
		<div class="actDiv">
			<span style="font-size: 1.5rem;">
				您本次一共抄了{{list.length}}个小区,已经成功完成了{{list.length}}个小区
			</span>
		</div>
		<a-table  size="small" :columns="columns" :data-source="list" bordered :loading="loading"  rowKey="neighborId" :pagination="{hideOnSinglePage:true}">
			
		</a-table>
	</div>
</template>

<script>
	export default{
		data(){
			const columns = [
				{
					title: '小区名',
					dataIndex: 'neighborName',
					width:140,
				},
				{
					title: '小区地址',
					dataIndex: 'neighborAddr',
					width:180,
				},
				
				{
					title: '集中器数量',
					dataIndex: 'gprsCount',
					width:80,
				},
				{
					title: '抄表结果',
					dataIndex: 'resultStr',
					width:160,
				},
				{
					title: '抄表IP',
					dataIndex: 'IP',
					width:120,
				},
				{
					title: '开始时间',
					dataIndex: 'startTime',
					width:160,
				},
				{
					title: '结束时间',
					dataIndex: 'endTime',
					width:160,
				},
			];
			return{
				columns,
				list:[],
				loading:false,
			}
		},
		methods:{
			queryDataList:function(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_ALL_RESULT_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						console.log(result);
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
		},
		created() {
			this.queryDataList();
		}
	}
</script>

<style>
</style>
